export default [
    {
        path: '/searchrest', // 休息室预订
        component: resolve => require(['@/pages/rest/searchRest'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/restDetail/:id', // 休息室详情
        component: resolve => require(['@/pages/rest/restDetail'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/restFillOrder',
        component: resolve => require(['@/pages/rest/fillOrder'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/restorderlist',
        component: resolve => require(['@/pages/rest/restOrderList'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/restorderdetail/:id',
        component: resolve => require(['@/pages/rest/restOrderDetail'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/dragonpassLoungeDetail', // 龙腾休息室详情
        component: resolve => require(['@/pages/rest/dragonpassLoungeOrderDetail'],resolve),
        meta: { title: "长龙航空" }
    }
]



// WEBPACK FOOTER //
// ./src/router/modules/rest.js